const common: Record<string, string> = {
  // Nav
  "nav.explore": "探索",
  "nav.discuss": "讨论",
  "nav.projects": "产品",
  "nav.post": "发布",
  "nav.login": "登录",
  "nav.join": "加入",
  "nav.search": "搜索",
  "nav.searchPlaceholder": "输入 handle 直达主页，如 yixian",
  "nav.searchEmpty": "先输入用户 handle（如 yixian 或 @yixian）",
  "nav.searchSoon": "全文搜索即将上线。现在可用：handle 直达主页；带连字符可试产品地址",
  "nav.searchGoExplore": "去探索浏览产品",
  "nav.notifications": "通知",
  "nav.profile": "个人主页",

  // Masthead (site cover)
  "masthead.tagline": "创造者体验 × 客户体验",
  "masthead.deck": "dev.cx 中的 cx 代表 customer experience。既是开发者使用社区的体验，也是社区作品面向真实客户的体验 —— 不圈地自萌，不闭门造车。",
  "masthead.colophonLabel": "本周社区",
  "masthead.prevWeekly": "上期周刊",
  "masthead.readWeekly": "阅读",
  // 首页匿名加入线索——整句散文语气,链接嵌在句中(非 · 并列表)
  "home.joinLeadSoft": "邀请制社区。",
  "home.joinInviteLink": "用邀请码加入",
  "home.joinOr": "，或",
  "home.joinWaitlistLink": "留下邮箱候补",
  "home.joinEnd": "。",
  // 页脚更弱的二次出口
  "home.joinFooterInvite": "加入",
  "home.joinFooterWaitlist": "候补",
  "masthead.colBuilders": "Builder",
  "masthead.colProducts": "产品",
  "masthead.colDiscussions": "讨论",
  "masthead.statsBuilders": "位 Builder 活跃",
  "masthead.statsProjects": "个产品",
  "masthead.statsDiscussions": "条讨论",

  // Masthead (now compact weekly banner)
  "weekly.bannerLabel": "周刊",
  "weekly.bannerViewFull": "查看完整周刊 →",
  "weekly.bannerPrev": "上一期",
  "weekly.bannerNext": "下一期",

  // Focus (now hero)
  "focus.heading": "本周焦点",
  "focus.deck": "社区成员本周正在打磨的作品与讨论。",
  "focus.statsBuilders": "位 Builder 活跃",
  "focus.statsProjects": "个产品",
  "focus.statsDiscussions": "条讨论",
  "focus.label": "Focus",
  "focus.sublabel": "本周焦点",
  "focus.mastheadLabel": "社区热点",
  "focus.mastheadDeck": "根据讨论热度自动排序，汇聚本周社区最活跃的作品与讨论。",
  // 首页 Focus 章节准则一行(API sort=trending = 近 7 天回复热度)
  "focus.rankingHint": "按近 7 天讨论回复热度自动排序，不是编辑手选。",
  "focus.feedback": "求反馈",
  "focus.trending": "本周热门",
  "focus.viewAll": "全部产品",
  "focus.viewAllCount": "全部 {{count}} 个产品",

  // Discussion chapter
  "discussion.label": "Discussion",
  "discussion.sublabel": "正在讨论",
  "discussion.replies": "条回复",
  "discussion.more": "更多",
  "discussion.viewAll": "查看全部讨论",
  "discussion.sortLatest": "最新",
  "discussion.sortHottest": "最热",

  // Profile
  "profile.status.building": "BUILDING",
  "profile.status.learning": "LEARNING",
  "profile.status.hiring": "HIRING",
  "profile.status.open": "OPEN",
  "profile.follow": "关注",
  "profile.following": "已关注",
  "profile.share": "分享",
  "profile.shareCopied": "链接已复制",
  "profile.shareFailed": "复制失败，请手动复制地址栏",
  "profile.thisWeek": "本周在做",
  "profile.updatedAt": "更新于",
  "profile.works": "产品",
  "profile.activity": "动态",
  "profile.about": "关于",
  "profile.followers": "关注者",
  "profile.noProjects": "挂上你正在做的东西",
  "profile.noProjectsHint": "你的主页会展示给社区里的其他人",
  "profile.viewAll": "全部",
  "profile.publicUrl": "公开主页",
  "profile.locationLabel": "位置",
  "profile.companyLabel": "状态",
  "profile.linksLabel": "链接",
  "profile.noActivity": "暂无动态",
  "profile.noActivityHint": "发布内容或更新项目后，动态会出现在这里",

  // Project
  "project.demo": "演示",
  "project.repo": "仓库",
  "project.docs": "文档",
  "project.writeProgress": "写进度",
  "project.postShow": "发 Show",
  "project.timeline": "时间线",
  "project.discuss": "讨论",
  "project.discuss.filterAll": "全部",
  "project.discuss.filterFeedback": "反馈",
  "project.feedback": "反馈",
  "project.feedback.submit": "提交反馈",
  "project.feedback.submitTitle": "提交反馈",
  "project.feedback.titleLabel": "标题",
  "project.feedback.titlePlaceholder": "简要描述你的反馈…",
  "project.feedback.needTitle": "请填写反馈标题",
  "project.feedback.needBody": "请填写反馈正文",
  "project.feedback.descriptionLabel": "描述",
  "project.feedback.descriptionPlaceholder": "详细说明问题或建议，越具体越容易被采纳…",
  "project.feedback.sortNewest": "最新",
  "project.feedback.sortReplies": "最多回复",
  "project.feedback.cancel": "取消",
  "project.feedback.submitSuccess": "反馈已提交，感谢你的贡献。",
  "project.feedback.submitError": "提交失败，请稍后重试。",
  "project.feedback.submitting": "提交中…",
  "project.feedback.merge": "合并",
  "project.feedback.mergeSelected": "合并选中",
  "project.feedback.mergeHint": "选择相似话题的帖子进行合并——选好后点击「合并选中」，然后选择保留哪个帖子作为主讨论。",
  "project.feedback.mergeTitle": "合并讨论",
  "project.feedback.mergeDescription": "选择一个帖子作为主讨论保留，其余帖子的内容将合并进去。主讨论通常是回复最多的那个。",
  "project.feedback.mergeConfirm": "确认合并",
  "project.feedback.mergedFrom": "合并来源",
  "project.feedback.mergedFromCount": "已合并 {{count}} 条讨论",
  "project.feedback.emptyHint": "反馈来自社区讨论帖。发帖时标记反馈类型，即可出现在这里。",
  "project.feedback.postFeedback": "发布反馈",
  "project.feedback.lockedTitle": "发布反馈",
  "project.feedback.lockedDeck": "你的反馈将关联到「{{project}}」，以讨论帖的形式发布。",
  "project.about": "关于",
  "project.createdBy": "创建者",
  "project.publicUrl": "产品地址",
  "project.publishedDays": "已发布 {{days}} 天",
  "project.metaUpdated": "{{time}}更新",
  "project.metaFounded": "{{date}} 立项",
  "project.locale": "zh-CN",
  "project.follow": "关注产品",
  "project.following": "已关注",
  "project.editProject": "编辑产品",
  "project.audience.endUsers": "终端用户",
  "project.audience.developers": "开发者",
  "project.audience.teams": "团队与企业",
  "project.audienceFacing": "面向{{audience}}",

  // New Project
  "newProject.title": "创建产品",
  "newProject.deck": "一个完整的产品主页，让社区更好地了解你在做什么",
  "newProject.deckCompact": "填名称与地址即可创建，其余选填、之后还能改。",
  "newProject.requiredHint": "* 必填 · 其余选填",
  "newProject.optionalSection": "介绍 / 标签 / 链接 / 截图（选填）",
  "newProject.expandOptional": "展开选填",
  "newProject.collapseOptional": "收起选填",
  "newProject.optionalCollapsedHint": "介绍、标签、链接、截图可创建后再补。",
  "newProject.formIncomplete": "还有必填项未完成或填写有误，请按提示修改后再创建。",
  "newProject.formIncompleteCount": "还有 {{count}} 处需要修改，请按下方列表逐项处理。",
  "newProject.jumpToError": "跳到第一处",
  "project.formIncomplete": "还有必填项未完成或填写有误，请按提示修改后再试。",
  "project.formIncompleteCount": "还有 {{count}} 处需要修改，请按下方列表逐项处理。",
  "project.jumpToError": "跳到第一处",
  "project.backToProduct": "返回产品页",
  "newProject.cancel": "取消",
  "newProject.create": "创建产品",
  "newProject.creating": "创建中...",
  "newProject.successTitle": "产品已创建",
  "newProject.successDesc": "你的产品主页已经准备好了",
  "newProject.viewProject": "查看产品页",
  "newProject.createAnother": "再建一个",

  // Compose
  "compose.title": "发布",
  "compose.deck": "高质量发布，每条帖子都值得被认真对待",
  "compose.chooseType": "选择类型",
  "compose.show": "Show",
  "compose.showSubtitle": "分享产品成果，获取反馈",
  "compose.build": "Build",
  "compose.buildSubtitle": "记录本周做了什么",
  "compose.ask": "Discuss",
  "compose.askSubtitle": "提出疑问、分享看法、发起讨论 —— 双向连接开发者与社区",
  "compose.discuss": "Discuss",
  "compose.discussSubtitle": "提出疑问、分享看法、发起讨论 —— 双向连接开发者与社区",

  "compose.project": "关联产品",
  "compose.projectDesc": "选择已有产品，或新建一个",
  "compose.projectPlaceholder": "搜索已有产品…",
  "compose.projectSearch": "搜索已有产品…",
  "compose.noProjectMatch": "未找到匹配产品",
  "compose.newProject": "新建产品",
  "compose.newProjectName": "产品名字",
  "compose.newProjectHint": "新建的产品将自动与此帖关联",
  "compose.titleField": "标题",
  "compose.titlePlaceholder": "一个吸引人的标题…",
  "compose.oneLiner": "一句话",
  "compose.oneLinerPlaceholder": "用一句话概括核心亮点",
  "compose.body": "正文",
  "compose.bodyPlaceholder": "写下你的思路、过程、结果…",
  "compose.sectionContent": "内容核心",
  "compose.contentDesc": "标题、一句话和正文",
  "compose.sectionShowcase": "展示补充",
  "compose.showcaseDesc": "阶段和外部链接",
  "compose.sectionFeedback": "反馈引导",
  "compose.feedbackDesc": "引导社区给出你想要的反馈",
  "compose.links": "链接",
  "compose.addLink": "添加链接",
  "compose.linkLabel": "名称",
  "compose.linkLabelShort": "名称",
  "compose.linkUrl": "地址",
  "compose.linkUrlShort": "地址",
  "compose.confirm": "确认",
  "compose.cancel": "取消",
  "compose.feedbackWanted": "求反馈",
  "compose.feedbackOptional": "可选，点一下就行",
  "compose.feedbackHint": "具体想问什么写进正文即可——帖子页的「求反馈」色带会带上这些标签。",
  "compose.feedbackChip.correctness": "算法正确性",
  "compose.feedbackChip.performance": "性能测试",
  "compose.feedbackChip.uiux": "UI / UX",
  "compose.feedbackChip.copy": "文案",
  "compose.feedbackAddCustom": "+ 自定义",
  "compose.typeKeepHint": "类型随时可切，内容不丢",
  "compose.projectRequired": "必选",
  "compose.projectNone": "不关联",
  "compose.viewPost": "查看帖子",
  "compose.lockedBuildTitle": "发布进展",
  "compose.lockedBuildDeck": "这条进展将发布在「{{project}}」的时间线上。",
  "compose.lockedShowTitle": "分享成果",
  "compose.lockedShowDeck": "向社区展示「{{project}}」的最新成果。",
  "compose.addFeedbackChip": "添加反馈类型",
  "compose.uncertainties": "不确定点",
  "compose.addUncertainty": "添加不确定点",

  "compose.done": "做了",
  "compose.doneDesc": "本周完成了什么值得记录的事",
  "compose.donePlaceholder": "本周完成了什么…",
  "compose.blockers": "卡点",
  "compose.blockersDesc": "当前遇到什么阻碍",
  "compose.blockersPlaceholder": "遇到了什么阻碍…",
  "compose.next": "下步",
  "compose.nextDesc": "接下来计划推进什么",
  "compose.nextPlaceholder": "接下来计划做什么…",

  "compose.tags": "标签",
  "compose.tagsPlaceholder": "输入标签，回车添加",
  "compose.askTitlePlaceholder": "简明扼要地描述你的问题…",
  "compose.askDesc": "详细描述你的问题，包括背景、已尝试的方案和期望结果",

  "compose.saveDraft": "存草稿",
  "compose.savingDraft": "保存中…",
  "compose.loadingDraft": "正在加载草稿…",
  "compose.draftNotEditable": "这篇不是可编辑的草稿",
  "compose.draftNeedsProject": "Show / Build 草稿请先选择关联产品",
  "compose.editNotAllowed": "已超过编辑时限或已有他人回复，无法编辑",
  "compose.saveEdit": "保存修改",
  "compose.saveAndView": "保存并查看",
  "thread.edited": "已编辑",
  "thread.edit": "编辑",
  "compose.preview": "预览",
  "compose.publish": "发布",
  "compose.publishing": "发布中...",
  "compose.published": "已发布",
  "compose.publishedDesc": "你的内容已发布到社区",
  "compose.needTitle": "请先填写标题",
  "compose.needBody": "请先填写正文",
  "compose.needProjectToPublish": "Show / Build 必须先关联一个产品才能发布",
  "compose.needProjectCreateFirst": "你还没有产品。Show / Build 需要先创建产品再发布。",
  "compose.needEmailVerify": "请先验证邮箱后再发布——查收验证邮件，或点页面顶部横幅重发",
  "compose.noProjectsYet": "你还没有产品。发 Show / Build 前请先创建一个。",
  "compose.createProjectFirst": "去创建产品 →",
  "compose.viewFeed": "查看讨论",
  "compose.copyProfile": "复制主页",
  "compose.copySummary": "复制摘要",
  "compose.newPost": "再发一篇",
  "compose.autoSaved": "已保存于 {time}",
  "compose.showTitlePlaceholder": "给分享起个标题...",
  "compose.buildTitlePlaceholder": "工作日志标题...",
  "compose.buildBodyPlaceholder": "写下你的工作日志 —— 这周做了什么、卡在哪儿、下一步计划…",
  "compose.discussTitlePlaceholder": "给讨论/提问起个标题...",
  "compose.discussBodyPlaceholder": "分享一个有意思的产品、提出你的疑问、或发起一场社区讨论 —— 贴上链接，写下你的想法。",
  "compose.discussProjectLabel": "向「{{name}}」发起对话",
  "compose.removeProject": "移除产品",

  // Theme
  "theme.warm": "暖黄",
  "theme.light": "纯白",
  "theme.dark": "暗色",

  // Thread
  "thread.breadcrumb.show": "Show",
  "thread.breadcrumb.build": "Build",
  "thread.breadcrumb.discuss": "Discuss",
  "thread.links": "产品引用",
  "thread.noLinks": "独立帖子 · 无关联产品",
  "thread.feedbackWanted": "求反馈",
  "thread.uncertainties": "不确定点",
  "thread.sort": "排序",
  "thread.sortLatest": "最新",
  "thread.sortEarliest": "最早",
  "thread.report": "举报",
  "thread.reply": "回复",
  "thread.authorBadge": "作者",
  "thread.sendReply": "发布回复",
  "thread.sending": "发送中…",
  "thread.needBody": "请先写点内容再发布",
  "thread.replyLogin": "登录后回复",
  "thread.replyPlaceholder": "写下你的想法…",
  "thread.replyTo": "回复 #{floor} 楼",
  "thread.send": "发送",
  "thread.cancel": "取消",
  "thread.replyCount": "条回复",
  "thread.floor": "{floor} 楼",
  "thread.expandChildren": "展开 {count} 条回复",
  "thread.collapseChildren": "收起回复",
  "thread.loadMore": "加载更多回复",
  "thread.allRepliesLoaded": "已加载全部回复",
  "thread.composerCollapsed": "写回复…",
  "thread.mergedFromBanner": "合并了 {{count}} 条相关讨论",
  "thread.mergedInto": "该讨论已合并到：",
  "thread.hiddenLabel": "已隐藏",
  "thread.hiddenPost": "此内容因违反社区规范已被隐藏",
  "thread.hiddenReasonLabel": "原因",
  "thread.hiddenOwnBanner": "这条内容已被隐藏，仅你自己与管理员可见",
  "thread.hiddenReply": "此回复已被隐藏",
  "thread.hiddenReplyOwn": "此回复已被隐藏（仅你与管理员可见）",

  // Admin 就地处置(Task 9)
  "admin.inlineLabel": "OP",
  "admin.reasonPrompt": "处置原因（会展示在墓碑上）：",
  "admin.deletePrompt": "硬删原因（仅违法内容使用；不可恢复）：",
  "admin.hidePost": "隐藏此帖",
  "admin.unhidePost": "恢复此帖",
  "admin.hide": "隐藏",
  "admin.unhide": "恢复",
  "admin.delete": "删除",

  // Admin 功能页 /admin(Task 10)
  "admin.title": "运营台",
  "admin.userSection": "用户处置",
  "admin.auditSection": "处置记录",
  "admin.auditEmpty": "还没有处置记录",
  "admin.handlePlaceholder": "输入 handle 查用户",
  "admin.lookup": "查询",
  "admin.userNotFound": "没有这个用户",
  "admin.warnCount": "累计警告",
  "admin.mutedUntil": "禁言至",
  "admin.suspendedAt": "已停用于",
  "admin.warn": "警告",
  "admin.warnPrompt": "警告内容（将以站内通知送达）：",
  "admin.mute": "禁言（默认 7 天）",
  "admin.unmute": "解除禁言",
  "admin.suspend": "停用账号",
  "admin.suspendPrompt": "停用原因（该用户将无法登录）：",
  "admin.unsuspend": "恢复账号",
  "admin.loadMore": "加载更多",

  // Admin 配置与邀请码(Task 19)
  "admin.settingsSection": "系统配置",
  "admin.settingsHint": "读取顺序：数据库优先，环境变量兜底。密钥类只写不回显；保存即生效。SMTP 用 587/STARTTLS 形态（465 隐式 TLS 不支持）。",
  "admin.settingsSMTP": "SMTP（邮件通道）",
  "admin.settingsOAuth": "GitHub OAuth",
  "admin.settingsSave": "保存",
  "admin.settingsResetBtn": "回退 env",
  "admin.settingsSaved": "已保存，即刻生效",
  "admin.settingsReset": "已回退到环境变量",
  "admin.secretSet": "已配置（不回显）",
  "admin.secretUnset": "未配置",
  "admin.smtpTestBtn": "发测试邮件",
  "admin.smtpTestOK": "测试邮件已发出",
  "admin.smtpTestFail": "发送失败：检查配置或查看 api 日志",
  "admin.invitesSection": "邀请码",
  "admin.invitesNotePlaceholder": "批次备注（如 w32-batch）",
  "admin.invitesMint": "造码",
  "admin.invitesVoid": "作废",
  "admin.invitesLinkHint": "把注册链接发给对方即可；打开后会自动填入邀请码（/onboarding?code=…）。",
  "admin.invitesFreshTitle": "刚生成的邀请（复制链接发给对方）",
  "admin.invitesCopyLink": "复制链接",
  "admin.invitesCopyAllLinks": "复制全部链接",
  "admin.invitesLinkCopied": "已复制",
  "admin.waitlistCount": "候补名单",

  // Onboarding(注册单屏:只收账号四件套;字段类 key 与 /me/profile、/new-project 复用)
  "onboarding.inviteApplied": "邀请码已自动填入",
  "onboarding.handleHint": "主页地址将是 dev.cx/@用户名；显示名默认与它相同，注册后可在「编辑资料」修改",
  "onboarding.displayName": "显示名",
  "onboarding.displayNamePlaceholder": "你的名字",
  "onboarding.handle": "用户名",
  "onboarding.handlePlaceholder": "your-handle",
  "onboarding.bio": "简介",
  "onboarding.bioPlaceholder": "简短介绍一下自己，比如你在做什么、感兴趣的方向…",
  "onboarding.status": "状态",
  "onboarding.statusBuilding": "Building",
  "onboarding.statusExploring": "Exploring",
  "onboarding.statusPaused": "Paused",
  "onboarding.statusSupporting": "Supporting",
  "onboarding.projectNamePlaceholder": "你的产品叫什么",
  "onboarding.projectDeckPlaceholder": "这个产品是做什么的",
  "onboarding.projectStage": "阶段",
  "onboarding.projectLink": "链接（可选）",
  "onboarding.projectLinkPlaceholder": "GitHub 或其他链接",

  // Feed / Explore
  "feed.title": "最新",
  "feed.allDiscussions": "全部讨论",
  "feed.totalDiscussions": "共 {{count}} 条",
  "feed.all": "全部",
  "feed.show": "Show",
  "feed.build": "Build",
  "feed.discuss": "Discuss",
  "feed.today": "今天",
  "feed.yesterday": "昨天",
  "feed.thisWeek": "本周早些时候",
  "feed.noResults": "暂无内容",
  "feed.loadMore": "加载更多",

  "explore.title": "探索",
  "explore.label": "Explore",
  "explore.allProducts": "全部产品",
  "explore.totalProducts": "共 {{count}} 个产品",
  "explore.mastheadDate": "二〇二六 · 七月",
  "explore.indexTitle": "产品索引",
  "explore.issueCount": "本期收录 {{count}} 个产品",
  "explore.sectionLabel": "栏目",
  "explore.filterStage": "阶段",
  "explore.filterAll": "全部",
  "explore.stageAll": "全部",
  "explore.sort": "排序",
  "explore.sortTrending": "热门",
  "explore.sortLatest": "最新",
  "explore.latest": "最新",
  "explore.views": "次浏览",
  "explore.topic": "话题",
  "explore.noResults": "暂无产品",
  "explore.loadMore": "加载更多",

  // Footer
  "footer.improve": "完善你的创造者主页",
  "footer.joinCue": "邀请制 · 有码加入 · 无码候补",
  "footer.loginPrompt": "未登录",
  "footer.loginPromptDesc": "登录后才能完善你的创造者主页，是否前往登录？",
  "footer.goLogin": "去登录",
  "footer.cancel": "取消",
  "footer.login": "登录 dev.cx",
  "footer.about": "关于",
  "footer.guidelines": "社区规范",
  "footer.report": "举报",
  "footer.privacy": "隐私",
  "footer.terms": "协议",

  // Mobile tabs
  "mobile.discover": "发现",
  "mobile.latest": "讨论",
  "mobile.post": "发布",
  "mobile.join": "加入",
  "mobile.notifications": "通知",
  "mobile.me": "我",

  // About
  "about.title": "关于 dev.cx",
  "about.deck": "产品驱动的创造者社区——不分工具，不限身份。你手写代码也好，用 AI 也罢，重要的是你在创造。",
  "about.pitch": "dev.cx 想做一件事：给每一个创造者一个像样的地方，认真讨论自己正在做的东西。不限制工具，不区分身份。",
  "about.whyTitle": "为什么做",
  "about.why.p1": "创造者的交流散落在微信群、即刻、Twitter 和各种封闭社区里。信息碎片化，讨论缺乏上下文——你在一个群里聊了三天产品，三天后就沉到底下了。",
  "about.why.p2": "dev.cx 把讨论锚定在产品上。每个创造者有一个公共主页，展示你正在做的东西、工具栈和思考过程。它不是简历，是一张持续更新的创造者名片。",
  "about.principles.title": "社区理念",
  "about.principles.p1": "质量优先于数量。首页每周更新一次焦点精选，而不是每分钟推新内容。",
  "about.principles.p2": "安静编辑。没有红点轰炸，没有算法推荐。你来这里是因为想认真看点什么。",
  "about.principles.p3": "开放透明。社区规范公开，项目进度公开，讨论过程公开。dev.cx 本身也是在 dev.cx 上被开发的项目。",
  "about.principles.p4": "数据可导出。你在这里发布的一切都属于你，登录后在个人页设置里随时打包带走。",
  "about.sealLabel": "dev.cx 编辑部",
  "about.contact.title": "联系",
  "about.contact.p1": "代码已开源（AGPL-3.0），欢迎围观与贡献。有问题发邮件。",
  "about.email": "邮件",
  "about.backToCommunity": "回到社区",
  "about.guidelinesLink": "社区规范",
  "about.colophon.version": "第1版",
  "about.colophon.builtOn": "构建于",
  "about.colophon.year": "二〇二六 · 七月",
  "about.colophon.typeset": "排版",

  // Notifications
  "notifications.title": "通知",
  "notifications.today": "今天",
  "notifications.yesterday": "昨天",
  "notifications.thisWeek": "本周早些时候",
  "notifications.empty": "暂无通知",
  "notifications.allRead": "全部已读",
  "notifications.unreadCount": "条未读",
  "notifications.markAllRead": "标记全部已读",
  "notifications.typeMention": "提及",
  "notifications.typeReply": "回复",
  "notifications.typeFollow": "关注",
  "notifications.typeUpdate": "更新",
  "notifications.typeModeration": "管理",
  "notifications.mentionedYou": "在讨论中提到了你",
  "notifications.repliedTo": "回复了你的帖子",
  "notifications.followedYou": "关注了你",
  "notifications.projectUpdate": "产品更新",
  "notifications.moderationNotice": "向你发出了一次管理提醒",
  "notifications.in": "在",

  // Me
  "me.title": "个人中心",
  "me.editProfile": "编辑主页",
  "me.myProjects": "我的产品",
  "me.myPosts": "我的发布",
  "me.drafts": "草稿箱",
  "drafts.deck": "未发布的草稿，继续编辑或删除。",
  "drafts.loginRequired": "登录后查看你的草稿",
  "drafts.loading": "加载中…",
  "drafts.empty": "还没有草稿",
  "drafts.write": "去写一篇",
  "drafts.untitled": "无标题草稿",
  "drafts.continue": "继续",
  "drafts.delete": "删除",
  "me.bookmarks": "收藏",
  "me.settings": "设置",
  "me.export": "导出我的数据（JSON）",
  "me.emailWeekly": "周报邮件",
  "me.emailWeeklyOn": "开",
  "me.emailWeeklyOff": "关",
  "me.signOut": "退出登录",
  "me.profilePreview": "主页预览",
  "me.changeAvatar": "更换头像",
  "me.copyProfileLink": "复制主页链接",
  "me.copied": "已复制",
  "me.publicProfile": "公开主页",
  "me.quickActions": "快捷操作",
  "me.account": "账户",
  "me.content": "内容",
  "me.misc": "其他",
  "me.statusUpdate": "更新状态",
  "me.quickProject": "快速创建产品",
  "me.quickProjectDeck": "只需填产品名即可创建，剩余信息稍后再补",
  "me.quickProjectCreate": "创建产品",
  "me.status.title": "更新状态",
  "me.status.deck": "记录本周的进展，让社区了解你的节奏",
  "me.status.fieldLabel": "本周状态",
  "me.status.placeholder": "本周做了什么、卡在哪、下一步打算…一句话也行",
  "me.status.save": "更新状态",
  "me.status.saving": "保存中...",
  "me.status.saved": "状态已更新",
  "me.status.savedDesc": "你的主页已显示最新状态",
  "me.status.viewProfile": "查看主页",
  "me.status.updateAgain": "继续编辑",
  "me.profile.title": "编辑资料",
  "me.profile.deck": "显示名、简介与当前状态",
  "me.profile.save": "保存",
  "me.setup.title": "把主页立起来",
  "me.setup.profile": "写句简介，选个状态",
  "me.setup.project": "挂上你的第一个产品",
  "me.setup.status": "跟大家打个招呼——最近在做什么",
  "me.followedProjects": "关注的产品",

  // My Projects
  "myProjects.title": "我的产品",
  "myProjects.count": "个产品",
  "myProjects.empty": "还没有产品，去探索页发现灵感吧",
  "myProjects.noDeck": "暂无描述",

  // Weekly magazine
  "weekly.title": "第 {week} 周周报",
  "weekly.back": "← 回到首页",
  "weekly.comingSoon": "本周周刊还在路上",
  "weekly.weekNav": "第 {{week}} 周",
  "weekly.theme": "本周主题",
  "weekly.editorNote": "编者按",
  "weekly.highlights": "本周精选",
  "weekly.projectHighlight": "作品",
  "weekly.discussionHighlight": "讨论",
  "weekly.replies": "读者评论",
  "weekly.replyCount": "条评论",
  "weekly.replyLoginHint": "登录后参与评论",
  "weekly.composerCollapsed": "写下对本期周报的看法…",
  "weekly.replyPlaceholder": "分享你对本期周报的想法…",

  // Guidelines
  "guidelines.title": "社区规范",
  "guidelines.deck": "dev.cx 是创造者体验优先的社区。以下规范帮助我们保持高质量、低噪音的讨论环境。",
  "guidelines.section1.title": "内容质量",
  "guidelines.section1.p1": "每条发布都应该有价值——无论是分享项目进度、提出技术问题还是展示成果。避免纯吐槽、无实质内容的灌水帖。",
  "guidelines.section1.p2": "Show 帖需要有可查看的东西（演示链接、截图、代码仓库）。Build 帖需要记录具体的进展，不是「这周没做什么」。Discuss 帖需要描述清楚背景、已尝试的方案和期望结果。",
  "guidelines.section2.title": "讨论礼仪",
  "guidelines.section2.p1": "保持友善和尊重。即使对某人的技术方案有不同意见，也请针对方案本身而非人身攻击。",
  "guidelines.section2.p2": "回帖前先读完主帖和已有回复，避免重复回答已经被讨论过的问题。如果你的回复是对某个楼层观点的延伸，请使用回复功能而非新开一条评论。",
  "guidelines.section3.title": "反馈文化",
  "guidelines.section3.p1": "发布产品时，请明确说明你希望获得什么类型的反馈。这能让回复者更有针对性地帮助你。",
  "guidelines.section3.p2": "给他人反馈时，尽量具体。与其说「很棒」，不如说「API 的设计思路很清晰，但错误处理的边界情况可以再补充一下」。",
  "guidelines.section4.title": "产品导向",
  "guidelines.section4.p1": "dev.cx 的所有讨论都围绕产品展开。即使是技术问答，也请关联到你正在做的具体产品。",
  "guidelines.section4.p2": "产品主页是你的创造者名片。保持更新——长期不维护的页面对社区是一种信息噪音。",
  "guidelines.section5.title": "冲突与处理",
  "guidelines.section5.p1": "如果出现违反规范的行为（人身攻击、垃圾广告、恶意刷帖等），管理员有权删除内容、警告或禁言。",
  "guidelines.section5.p2": "如果你认为自己的内容被误删或处理不当，可以通过关于页的联系渠道申诉。",
  "guidelines.backToCommunity": "回到社区",

  // Privacy
  "privacy.title": "隐私政策",
  "privacy.deck": "dev.cx 收集尽可能少的数据，并把它们只用在让社区运转的地方。本页说明我们收集什么、为什么、以及你对自己数据的权利。",
  "privacy.section1.title": "collect / 我们收集什么",
  "privacy.section1.p1": "注册时：邮箱、密码（仅存哈希）、你选择的 handle 与昵称。使用 GitHub 登录时：仅获取 GitHub 登录名与邮箱，不请求仓库或其他权限。",
  "privacy.section1.p2": "使用中：你发布的内容（项目、帖子、回复、图片）、关注关系、以及维持服务所需的基础访问日志。没有广告追踪，没有第三方分析 cookie——唯一的 cookie 是登录会话。",
  "privacy.section2.title": "use / 我们用它做什么",
  "privacy.section2.p1": "邮箱用于登录、验证与站内事件通知（如回复提醒），不会用于营销，也绝不出售或共享给第三方。",
  "privacy.section2.p2": "访问日志仅用于故障排查与滥用防护（如限流），不做画像。",
  "privacy.section3.title": "third parties / 第三方服务",
  "privacy.section3.p1": "GitHub（OAuth 登录，仅 login 与邮箱）；img.li（图片存储，你上传的图片保存在那里）；自托管邮件服务（发送验证与通知邮件）。",
  "privacy.section3.p2": "服务器部署在中国大陆境外。你发布的公开内容（主页、项目、帖子）可被搜索引擎索引——这正是「可外链的公共档案」的设计意图。",
  "privacy.section4.title": "your rights / 你的数据权利",
  "privacy.section4.p1": "你可以随时在设置页一键导出自己的全部内容（JSON）。这是产品承诺，不只是合规条款。",
  "privacy.section4.p2": "需要删除账号，发邮件到 report@dev.cx，我们会在合理时间内处理并确认。若服务停止运营，将提前 6 个月通知并保留导出通道（善终条款）。",
  "privacy.section5.title": "changes / 变更",
  "privacy.section5.p1": "政策修订会在本页更新并注明日期；重大变更会在站内公告。",
  "privacy.section5.p2": "本政策更新于 2026-07-27。对政策有疑问，写信到 report@dev.cx。",
  "privacy.backToCommunity": "回到社区",

  // Terms
  "terms.title": "用户协议",
  "terms.deck": "dev.cx 是一个邀请制的创造者社区。这份协议尽量说人话：你的内容是你的，社区规范是认真的，我们对「哪天不做了」也有交代。",
  "terms.section1.title": "account / 账号",
  "terms.section1.p1": "注册需要邀请码与邮箱验证。账号由你本人使用并保管，账号下的行为视为你的行为。",
  "terms.section1.p2": "handle 是你在站内的唯一标识。允许改名（约 90 天一次），旧 handle 永久重定向到新主页且不开放注册。",
  "terms.section2.title": "your content / 你的内容",
  "terms.section2.p1": "你发布的内容著作权归你。你授予 dev.cx 为运营所需的展示与分发权（在站内呈现、生成周刊摘要、被搜索引擎索引）。",
  "terms.section2.p2": "你可以随时导出全部内容。删除内容或账号后，我们不再展示，但备份中的副本会随备份周期自然过期。",
  "terms.section3.title": "conduct / 社区规范与处置",
  "terms.section3.p1": "成文规范见 /guidelines。红线（违法诈骗、侵犯隐私、人身攻击、严重侵权）会被处置：内容隐藏（保留墓碑与原因）、警告、限期禁言或停用账号；仅违法内容会被彻底删除。",
  "terms.section3.p2": "所有处置动作都有内部审计记录。对处置有异议，写信到 report@dev.cx 申诉。",
  "terms.section4.title": "handle policy / handle 政策",
  "terms.section4.p1": "冒充他人（用知名者名字暗示本人）的 handle 可被收回。同名不等于冒充——我们拒绝的是行为，不是标签。",
  "terms.section4.p2": "从未使用的纯占位 handle（如 12 个月零内容且有人正当认领）可能被回收，回收前会邮件通知并留缓冲期；曾经活跃后停更是合法状态，不会被回收。",
  "terms.section5.title": "service / 服务与承诺",
  "terms.section5.p1": "dev.cx 是长期兴趣项目，服务按现状提供，不承诺可用性指标。运营者也是 builder，也会有暂停周——静默期间红线处理仍然保障。",
  "terms.section5.p2": "三个公开承诺：数据可随时导出；若停运提前 6 个月通知并保留导出通道；聚光灯（首页与周刊位置）永不出售。",
  "terms.section6.title": "termination / 终止",
  "terms.section6.p1": "严重或屡次违规会导致账号停用。你也可以随时要求删除自己的账号（见隐私政策）。",
  "terms.section6.p2": "本协议更新于 2026-07-27。继续使用视为接受当前版本；重大变更会在站内公告。",
  "terms.backToCommunity": "回到社区",

  // 注册同意句。legal.and 是英文连接词槽位（" and the "）——中文书名号天然相连，留空即可。
  "legal.consent": "注册即表示你同意",
  "legal.terms": "《用户协议》",
  "legal.and": "",
  "legal.privacy": "《隐私政策》",

  // Login
  "login.kicker": "Account · 登录",
  "login.title": "登录 dev.cx",
  "login.deck": "登录以发布、回复和创建你的创造者主页",
  "login.registerTitle": "加入 dev.cx",
  "login.registerDeck": "dev.cx 采用邀请制，需要有效的邀请码才能注册",
  "login.forgotTitle": "重置密码",
  "login.forgotDeck": "输入注册邮箱，我们会发送验证码",
  "login.email": "邮箱",
  "login.emailPlaceholder": "your@email.com",
  "login.password": "密码",
  "login.passwordPlaceholder": "输入密码",
  "login.passwordPlaceholderRegister": "至少 8 个字符",
  "login.passwordHint": "密码至少 8 个字符",
  "login.confirmPassword": "确认密码",
  "login.confirmPasswordPlaceholder": "再次输入密码",
  "login.newPassword": "新密码",
  "login.newPasswordPlaceholder": "输入新密码",
  "login.inviteCode": "邀请码",
  "login.inviteCodePlaceholder": "输入你的邀请码",
  "login.inviteHint": "目前仅限邀请注册。如果你还没有邀请码，请关注我们的社交媒体获取。",
  "login.verificationCode": "验证码",
  "login.sendCode": "发送验证码",
  "login.resendCode": "重新发送",
  "login.sending": "发送中…",
  "login.codeSent": "验证码已发送，请查收邮箱",
  "login.submit": "登录",
  "login.registerSubmit": "创建账号",
  "login.submitting": "处理中…",
  "login.forgotPassword": "忘记密码？",
  "login.resetPassword": "重置密码",
  "login.passwordResetSuccess": "密码已重置，即将返回登录",
  "login.backToHome": "返回首页",
  "login.backToLogin": "返回登录",
  "login.oauthHint": "或使用第三方账号",
  "login.oauthComingSoon": "即将支持",
  "login.oauthGitHubAria": "使用 GitHub 登录",
  "login.oauthGoogleAria": "Google 登录即将支持，请先用 GitHub 或邮箱",
  "login.oauthFootnote": "目前仅开放 GitHub；Google 登录接入后会在此启用",
  "login.errorRequired": "请填写邮箱和密码",
  "login.errorEmailRequired": "请输入邮箱",
  "login.errorInviteRequired": "该 GitHub 账号还没有绑定过 dev.cx 账号——目前注册需要邀请码。",
  "login.errorCodeRequired": "请输入验证码",
  "login.errorPasswordMismatch": "两次输入的密码不一致",
  "login.errorPasswordShort": "密码长度至少 6 位",
  "login.errorSendCode": "发送验证码失败，请稍后重试",
  "login.errorGeneric": "登录失败，请重试",
  "login.errorSuspended": "账号已停用。如有异议请联系 report@dev.cx",
  "login.switchToRegister": "还没有账号？用邀请码注册 →",
  "login.switchToLogin": "已有账号？登录",

  // Me
  "me.loginRequiredTitle": "需要登录",
  "me.loginRequiredDesc": "登录后查看你的个人主页、产品和通知",

  // Notifications
  "notifications.loginRequiredTitle": "需要登录",
  "notifications.loginRequiredDesc": "登录后查看回复、提及和项目更新",

  // PostList
  "postList.replies": "回复",
  "postList.prevPage": "上一页",
  "postList.nextPage": "下一页",
  "postList.bookmark": "收藏",
  "postList.unbookmark": "取消收藏",

  // Project settings
  "project.settings": "产品设置",
  "project.settingsSubtitle": "管理产品的基础信息、链接、标签、截图等",
  "project.settingsSaved": "已保存",
  "project.saving": "保存中...",
  "project.saveSettings": "保存修改",
  "project.visibilitySection": "可见性",
  "project.publicBadge": "公开展示",
  "project.hiddenBadge": "已下架",
  "project.publicHelp": "当前对探索、他人主页与搜索可见。下架后访客将无法打开产品页。",
  "project.hiddenHelp": "已下架：仅你自己可见，不会出现在探索与他人主页。可随时恢复公开展示。",
  "project.hideAction": "下架隐藏",
  "project.unhideAction": "恢复公开展示",
  "project.visibilityWorking": "处理中…",
  "project.hiddenOwnerBanner": "此产品已下架，访客看不到。",
  "project.manageVisibility": "管理可见性 →",
  "project.basicInfo": "基本信息",
  "project.namePlaceholder": "你的产品叫什么",
  "project.tagline": "一句话简介",
  "project.taglinePlaceholder": "用一句话概括这个产品是做什么的",
  "project.stage": "当前阶段",
  "project.audienceLabel": "给谁用",
  "project.audienceHint": "可多选;开源库、CLI、SDK 选「开发者」。还不确定可以先空着,之后随时能改。",
  "project.description": "产品介绍",
  "project.descriptionPlaceholder": "用 Markdown 写产品介绍：核心功能、解决的问题、技术亮点、使用场景…",
  "project.tagsPlaceholder": "场景、领域或技术栈，回车添加",
  "project.links": "外部链接",
  "project.tags": "标签",
  "project.screenshots": "产品截图",
  "project.noScreenshots": "还没有截图",
  "project.addScreenshot": "添加截图",
  "project.uploadScreenshot": "上传图片",
  "project.screenshotUrlPlaceholder": "输入图片 URL...",
  "project.add": "添加",
  "project.addLink": "添加链接",
  "project.linkRemove": "删除链接",
  "project.linkLabelPlaceholder": "标签",
  "project.linkUrlPlaceholder": "https://...",
  "project.nameLabel": "产品名",
  "project.err.nameRequired": "产品名不能为空",
  "project.err.tooLong": "超出长度上限（{{max}} 字）",
  "project.err.tooMany": "数量超出上限（最多 {{max}} 个）",
  "project.err.tagTooLong": "单个标签最长 {{max}} 字",
  "project.err.linkIncomplete": "链接需要同时填写名称和地址",
  "project.err.urlScheme": "地址必须以 http:// 或 https:// 开头",
  "project.slugPlaceholder": "my-product",
  "project.slugHint": "小写字母、数字与中划线，2–32 位。这是产品的永久公开地址，创建后不可修改。",
  "project.err.slugRequired": "地址不能为空——用小写字母或数字起个短名",
  "project.err.slugInvalid": "只能用小写字母、数字和中划线（2–32 位，首尾须为字母或数字，不能连续中划线）",
  "project.err.slugTaken": "该地址已被占用，换一个试试",
  "project.addScreenshotsNudge": "添加产品截图，让主页更完整",
  "project.noDescription": "作者还没有写产品介绍",
  "project.writeDescription": "补写一段介绍 →",
  "project.timelineEmpty": "还没有进展记录",
  "project.timelineEmptyHint": "发布的 Build / Show 帖会按时间出现在这里",
  "project.discussEmpty": "还没有讨论",
  "project.stageIdea": "想法",
  "project.stageWIP": "进行中",
  "project.stageShipped": "已发布",
  "project.stagePaused": "暂停",

  // Thread
  "thread.replyLoginHint": "登录后参与讨论",

  // NotFound
  "notFound.title": "这一页不存在",
  "notFound.deck": "地址可能拼错了，或者这页已被移走。",
  "notFound.backHome": "回到首页 →",

  // Email verification
  "verify.banner": "你的邮箱还未验证，发布功能暂不可用。",
  "verify.resend": "重发验证邮件",
  "verify.resent": "已重发（注意查收，含垃圾箱）",
  "verify.label": "邮箱验证",
  "verify.pending": "验证中…",
  "verify.ok": "邮箱已验证，全部功能已解锁。",
  "verify.goHome": "回首页",
  "verify.fail": "链接无效或已过期。",
  "verify.failHint": "登录后可在页面顶部横幅重发验证邮件（链接 24 小时有效）。",

  // Password reset
  "login.forgot": "忘记密码？",
  "reset.sent": "如果该邮箱存在，重置邮件已发出（1 小时内有效）。",
  "reset.label": "重置密码",
  "reset.hint": "设置新密码（至少 8 位）。",
  "reset.placeholder": "新密码",
  "reset.submit": "重置并使所有设备下线",
  "reset.ok": "密码已重置，所有旧会话已失效。",
  "reset.goLogin": "去登录",
  "reset.fail": "链接无效或已过期。",
  "reset.failHint": "回登录页重新点「忘记密码」再试（链接 1 小时有效）。",

  // Waitlist(开闸前候补名单)
  "waitlist.prompt": "没有邀请码？留下邮箱，开放注册时通知你。",
  "waitlist.placeholder": "你的邮箱",
  "waitlist.submit": "排队",
  "waitlist.done": "已登记。开放时我们会写信给你。",
  "waitlist.invalidEmail": "请填写有效的邮箱地址",
};

export default common;